﻿import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'it',
    supportedLngs: ['it', 'en'],
    defaultNS: 'common',
    ns: ['common', 'visits', 'prospects', 'auth'],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['sessionStorage', 'localStorage', 'navigator'],
      lookupSessionStorage: 'lang',
      lookupLocalStorage: 'lang',
      caches: ['sessionStorage', 'localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
